import type * as Highcharts from 'highcharts';
import type { BeniBreakdown, BeniMetaComparisonSet } from 'lumen/models';
import type {
  Kpi,
  ReferencePeriod,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';
import type { DateAggregationType } from 'lumen/utils/constants/general-constants';

export const PACE_CHART_SERIES_IDS = {
  OWN: 'own',
  OWN_REFERENCE: 'ownReference',
  PRIMARY_COMPARISON_SET: 'primaryComparisonSet',
  PRIMARY_COMPARISON_SET_REFERENCE: 'primaryComparisonSetReference',
  SECONDARY_COMPARISON_SET: 'secondaryComparisonSet',
  SECONDARY_COMPARISON_SET_REFERENCE: 'secondaryComparisonSetReference',
};
export type PaceChartSeriesId =
  (typeof PACE_CHART_SERIES_IDS)[keyof typeof PACE_CHART_SERIES_IDS];

export interface PaceChartSeriesPoint {
  segmentation?: BeniBreakdown;
  showWarningForWeek?: boolean;
  x: number;
  y: number | null;
}

export interface PaceChartSeries extends Highcharts.SeriesOptions {
  color: Highcharts.ColorString | Highcharts.GradientColorObject;
  data: PaceChartSeriesPoint[];
  id?: PaceChartSeriesId;
  marker: {
    enabled: boolean;
  };
  name: string;
  visible: boolean;
}

export interface PaceChartSignature {
  Args: {
    dateAggregation: DateAggregationType;
    extractDate: string;
    ownComparisonSetBreakdowns: BeniBreakdown[];
    ownComparisonSetMeta: BeniMetaComparisonSet | null;
    primaryComparisonSetBreakdowns: BeniBreakdown[];
    primaryComparisonSetMeta: BeniMetaComparisonSet | null;
    referencePeriod: ReferencePeriod;
    secondaryComparisonSetBreakdowns: BeniBreakdown[];
    secondaryComparisonSetMeta: BeniMetaComparisonSet | null;
    selectedKpi: Kpi;
  };
}
